import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import styles from "./IndicatorsDashbord.module.css";
import { connect } from 'react-redux';
import BtnBack from '../helper/btnBack/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';
import back1 from '../../../assets/dashboard/background_1.png'
import circle from '../../../assets/dashboard/circle.png'

import { getStructure } from '../../../actions/report'

const IndicatorsDashbord = ({
  getStructure,
  structure
}) => {

  useEffect(() => {
    getStructure()
  }, [])

  return (
    <div className={styles.wrapper}>
      <img src={back1} className={styles.bg} />
      <GetHeader title={<>Показатели деятельности системы высшего военного образования</>} />

      <div className={styles.wrapperInner}>

        <div className={styles.wrapperCircle}>

          <div className={styles.leftSide}>
            <Link to='/dashboard/indicators/org' className={styles.leftSide_1} onClick={() => console.log(1)}>Показатели организации<br />образовательной деятельности <br />и качества подготовки <br />военных кадров</Link>
            <Link to='/dashboard/indicators/pers' className={styles.leftSide_2} onClick={() => console.log(2)}>Показатели кадрового обеспечения<br />образовательной деятельности</Link>
          </div>
          <div className={styles.centerSide}>
            <div className={styles.clickAreaWrapper}>
              <div className={styles.countIndicators}>44<span>ПОКАЗАТЕЛЯ</span></div>
              <Link to='/dashboard/indicators/org' className={styles.clickAreaL_T} onClick={() => console.log(1)}></Link>
              <Link to='/dashboard/indicators/info' className={styles.clickAreaR_T} onClick={() => console.log(2)}></Link>
              <Link to='/dashboard/indicators/pers' className={styles.clickAreaL_B} onClick={() => console.log(3)}></Link>
              <Link to={{ pathname: '/dashboard/list', state: { fromIndicators: true } }} className={styles.clickAreaR_B} onClick={() => console.log(4)}></Link>
            </div>

            <img src={circle} className={styles.circle} />
          </div>
          <div className={styles.rightSide}>
            <Link to='/dashboard/indicators/info' className={styles.rightSide_1} onClick={() => console.log(3)}>Показатели информационного<br />обеспечения образовательной<br />деятельности</Link>
            <Link to='/dashboard/indicators/activity' className={styles.rightSide_2} onClick={() => console.log(4)}>Показатели деятельности<br />военно-учебного заведения</Link>
          </div>
        </div>

        <div className={styles.panelWrapper}>
          <div className={styles.panel}>

            <div className={styles.monitor}>Мониторинг деятельности <mark>{structure[0]?.count}</mark> вузов</div>

            <ul className={styles.list}>
              {
                structure?.map((el, inx) => {
                  if (inx != 0) {
                    return <li className={styles.listItem}><mark>{el.count}</mark><span>{el.name}</span></li>
                  }
                })
              }
            </ul>
          </div>
        </div>
      </div>

      <BtnBack />

    </div>
  )
}

const mapStateToProps = (state) => ({
  structure: state.report.structure
});

export default connect(mapStateToProps, {
  getStructure
})(IndicatorsDashbord);